import { Controller } from 'stimulus';
import { templateContent } from '@/js/util';

export default class extends Controller {
  static targets = ['modal'];

  open(event) {
    event.preventDefault();

    document.body.append(templateContent(this.modalTarget));
  }
}
